module.exports = "<gw-dynamic-component\r\n        prefix=\"gwContactRole\"\r\n        variant=\"$ctrl.roleModel.accountContactRole ? $ctrl.roleModel.accountContactRole.subtype.value.code : $ctrl.roleModel.subtype.value.code\"\r\n        default-variant=\"default\"\r\n        props=\"{ roleModel: '$ctrl.roleModel', roleType: '{{ $ctrl.roleType }}', contactType: '{{ $ctrl.contactType }}' }\"\r\n></gw-dynamic-component>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/contacts/common/components/roles/ContactRole/ContactRole.html
// module id = 707
// module chunks = 0